import {submitPrint,submitDenonce,submitMemo} from "./utils_element";

export const printALD = function (data, callFunction) {
    submitPrint(data, callFunction, urls.printALD);
};

export const printDenonce = function (data, callFunction) {
    submitDenonce(data, callFunction, urls.generateDenonce);
};

export const sendMemo = function (data, callFunction) {
    submitMemo(data, callFunction, urls.sendMemo);
};





// WEBPACK FOOTER //
// ./assets/js/display_vh_stock.js